import { history, store } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import { routes } from 'Constants/routes';
import { SHARE_MODAL } from 'Constants/modals';
import { IsPreviousYear } from 'Types/common';

export const entertraimentActions = {
  presentation: {
    title: 'Dg.presentation.title',
    subtitle: 'Dg.presentation.subtitle',
    progress: 10,
  },
  profile: {
    onClick: (isPreviousYear?: IsPreviousYear): void =>
      history.push(routes.PERSONAL_PHONE, {
        products: isPreviousYear?.products,
      }),
    title: 'Dg.profile.title',
    subtitle: 'Dg.profile.subtitle',
    buttonLabel: 'Dg.profile.button',
  },
  efirma: {
    onClick: (isPreviousYear?: IsPreviousYear): void =>
      history.push(routes.DATAGATHERING_IDENTIFICATION_EFIRMA, {
        products: isPreviousYear?.products,
      }),
    title: 'Dg.efirma.title',
    subtitle: 'Dg.efirma.subtitle',
    tinyButton: 'Dg.efirma.tiny',
    tinyButtonClick: (isPreviousYear?: IsPreviousYear): void =>
      history.push(routes.DATAGATHERING_REFERRAL, {
        products: isPreviousYear?.products,
      }),
    buttonLabel: 'Dg.efirma.button',
  },
  referral: {
    onClick: (): void => store.dispatch(showModalAction({ options: { type: SHARE_MODAL } })),
    title: 'Dg.referral.title',
    subtitle: 'Dg.referral.subtitle',
    tinyButton: 'Dg.referral.tiny',
    tinyButtonClick: (isPreviousYear?: IsPreviousYear): void =>
      history.push(routes.DATAGATHERING_LOADER, {
        products: isPreviousYear?.products,
      }),
    buttonLabel: 'Dg.referral.button',
  },
  satError: {
    onClick: (): void => history.push(routes.DASHBOARD),
    title: 'Dg.sat.error.title',
    subtitle: 'Dg.sat.error.subtitle',
    buttonLabel: 'Dg.sat.error.button',
  },
  resultEstimated: {
    onClick: (isPreviousYear?: IsPreviousYear): void =>
      history.push(routes.DATAGATHERING_TYPEFORM_ESTIMATED_RESULT, {
        products: isPreviousYear?.products,
      }),
    title: 'Dg.result.estimated.title',
    subtitle: 'Dg.result.estimated.subtitle',
    buttonLabel: 'Dg.result.estimated.button',
  },
};
